import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-facility-dialog',
  templateUrl: './manual-facility-dialog.component.html',
  styleUrls: ['./manual-facility-dialog.component.css'],
  standalone: false,
})
export class ManualFacilityDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly facilityAttributeDialogLink: string = AppConst.ROUTING_LINK_MANUAL_FACILITY_ATTRIBUTE_DIALOG;
  readonly nameDialogLink: string = AppConst.ROUTING_LINK_MANUAL_NAME_DIALOG;
  readonly descDialogLink: string = AppConst.ROUTING_LINK_MANUAL_DESC_DIALOG;
  readonly addressDialogLink: string = AppConst.ROUTING_LINK_MANUAL_ADDRESS_DIALOG;
  readonly copyrightDialogLink: string = AppConst.ROUTING_LINK_MANUAL_COPYRIGHT_DIALOG;
  readonly policyDialogLink: string = AppConst.ROUTING_LINK_MANUAL_POLICY_DIALOG;
  readonly faqDialogLink: string = AppConst.ROUTING_LINK_MANUAL_FAQ_DIALOG;
  readonly uploaderLink: string = AppConst.ROUTING_LINK_MANUAL_UPLOADER;
  readonly floorDialogLink: string = AppConst.ROUTING_LINK_MANUAL_FLOOR_DIALOG;
  readonly youtubeDialogLink: string = AppConst.ROUTING_LINK_MANUAL_YOUTUBE_DIALOG;
  readonly urlDialogLink: string = AppConst.ROUTING_LINK_MANUAL_URL_DIALOG;
  readonly splatsLink: string = AppConst.ROUTING_LINK_MANUAL_SPLATS;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang
  }

}
